export default __webpack_public_path__ + "static/media/022-speed limit.8064e31b.png";